module.exports = __webpack_public_path__ + "img/menuIcon3.69060cd6.png";